<template>
  <div class="homeIndex">
    <!-- 弹框 -->
    <div class="addInfo">
      <div class="infoName">云管理</div>
      <div class="addBtn">
        <el-button type="primary" @click="addCloud" round>+ 新增</el-button>
        <el-dialog :title="dailogTitle" :visible.sync="dialogFormVisible" class="addCloud" :before-close="handleClose" v-if="dialogFormVisible" :close-on-click-modal="false">
          <el-form
            :model="cloudForm"
            ref="subCloudForm"
            :rules="cloudFormValidate"
            :label-width="formLabelWidth"
          >
            <el-form-item label="云名称：" prop="cloudName">
              <el-input v-model="cloudForm.cloudName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="服务代码：" prop="cloudServiceName">
              <el-input v-model="cloudForm.cloudServiceName" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="IP地址：" prop="ip">
              <el-input v-model="cloudForm.ip" autocomplete="off"></el-input>
            </el-form-item>
            <el-form-item label="类型：" prop="cloudType">
              <el-select v-model="cloudForm.cloudType" placeholder="请选择云服务类型" @change="changeType" style="width:100%" clearable filterable>
                <el-option
                  v-for="item in cloudTypes"
                  :key="item.id"
                  :label="item.cloudType"
                  :value="item.id"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item label="智能音箱服务地址：" prop="smartLoudspeakerBoxServiceUrl">
              <el-input v-model="cloudForm.smartLoudspeakerBoxServiceUrl" autocomplete="off"></el-input>
            </el-form-item>
          </el-form>
          <div slot="footer" class="dialog-footer">
            <el-button type="info" @click="cancelClick('subCloudForm')">取 消</el-button>
            <el-button type="primary" @click="confirm_add('subCloudForm')" class="submit" :loading="loadingsubmit">{{confirmText}}</el-button>
          </div>
        </el-dialog>
      </div>
    </div>
    <!-- 表格 -->
    <div class="tableInfo">
      <el-table v-loading="loading" :data="tableData" border style="width: 100%" :header-cell-style="{color: '#333'}">
        <el-table-column prop="cloudName" label="云名称" min-width="200">
        </el-table-column>
        <el-table-column prop="ip" label="IP地址" min-width="250"> </el-table-column>
        <el-table-column prop="cloudTypeName" label="类型" min-width="150"> </el-table-column>
        <el-table-column label="操作" width="200">
          <template slot-scope="{row}">
            <el-button type="text" size="small" @click="editCloud(row)" class="edit">修改</el-button>
            <el-divider direction="vertical"></el-divider>
            <el-button @click="delCloud(row)" type="text" size="small" class="delete">删除</el-button> 
          </template>
        </el-table-column>
      </el-table>
    </div>
    <!-- 分页 -->
    <div class="pagination">
      <el-pagination
        background
        @size-change="changeSize"
        @current-change="changePage"
        :current-page="current_page"
        :page-sizes="page_size_list"
        :page-size="page.pageSize"
        layout="prev, pager, next, sizes, total, jumper"
        :total="total">
      </el-pagination>
    </div>

    <!-- <div class="upload_xls">
      <el-upload
        class="upload-demo"
        action="#"
        :on-change="handleChange"
        :before-upload="beforeUpload"
        >
        <el-button size="small" type="primary">导入</el-button>
      </el-upload>
    </div>
    <div class="upload_xls">
      <el-button size="small" type="primary" @click="export_data">导出</el-button>
    </div>
    <div class="tableInfo" v-if="show">
      <el-table v-loading="loading" :data="upload_tableData" border style="width: 100%" :header-cell-style="{color: '#333'}">
        <el-table-column prop="name" label="名字" min-width="200">
        </el-table-column>
        <el-table-column prop="score" label="分数" min-width="250"> </el-table-column>
      </el-table>
    </div> -->
  </div>
</template>

<script>
import {readFile,character} from "@/utils/utils"
// import xlsx from 'xlsx'
import * as XLSX from 'xlsx';
import { cloud_config_tabledata,addCloudInfo,delCloudInfo } from "@/api";
const api = require("@/api")
var iplist = /^((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d))|\*)((\/([012]\d|3[012]|\d))?)(,((25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d)))\.){3}(25[0-5]|2[0-4]\d|((1\d{2})|([1-9]?\d))|\*)((\/([012]\d|3[012]|\d))?))*$/;
var urlist = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
var ipduan = /^(?=(\b|\D))(((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))\.){3}((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))(?=(\b|\D))-(?=(\b|\D))(((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))\.){3}((\d{1,2})|(1\d{1,2})|(2[0-4]\d)|(25[0-5]))(?=(\b|\D))$/;
var ipv6 = /^\s*((([0-9A-Fa-f]{1,4}:){7}([0-9A-Fa-f]{1,4}|:))|(([0-9A-Fa-f]{1,4}:){6}(:[0-9A-Fa-f]{1,4}|((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){5}(((:[0-9A-Fa-f]{1,4}){1,2})|:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3})|:))|(([0-9A-Fa-f]{1,4}:){4}(((:[0-9A-Fa-f]{1,4}){1,3})|((:[0-9A-Fa-f]{1,4})?:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){3}(((:[0-9A-Fa-f]{1,4}){1,4})|((:[0-9A-Fa-f]{1,4}){0,2}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){2}(((:[0-9A-Fa-f]{1,4}){1,5})|((:[0-9A-Fa-f]{1,4}){0,3}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(([0-9A-Fa-f]{1,4}:){1}(((:[0-9A-Fa-f]{1,4}){1,6})|((:[0-9A-Fa-f]{1,4}){0,4}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:))|(:(((:[0-9A-Fa-f]{1,4}){1,7})|((:[0-9A-Fa-f]{1,4}){0,5}:((25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)(\.(25[0-5]|2[0-4]\d|1\d\d|[1-9]?\d)){3}))|:)))(%.+)?\s*$/;
export default {
  data() {
    return {
      show: false,
      upload_tableData: [],
      loading: false,
      loadingsubmit: false,
      confirmText: '确定',
      //dialog
      apiName: "",
      successMsg: "",
      errorMag: "",
      dailogTitle: "",
      dialogFormVisible: false,
      // dialogFormVisible2: false,
      cloudForm: {
        cloudName: null,
        ip: null,
        cloudType: null,
        smartLoudspeakerBoxServiceUrl: null,
      },
      cloudTypes:[
        {id:1,cloudType:"智慧校园"},
        {id:2,cloudType:"智能家居"},
        {id:3,cloudType:"智慧客控"},
        {id:4,cloudType:"智能照明"},
      ],
      cloudFormValidate: {
        cloudName: [
          {required: true, message: "请输入云名称", trigger: "blur",},
          {
            validator: function(rule, value, callback) {
              if (/^[A-Za-z0-9-_\u4e00-\u9fa5]{2,30}$/.test(value) == false) {
                callback(new Error("只能输入2-30个包含中文、字母、数字、中划线、下划线的名称"));
              } else {
                //校验通过
                callback();
              }
            },
            trigger: "blur"
          }
        ],
        // ip:[
        //   {required:true, message:'请输入IP地址', trigger:'blur'},
        //   {validator:function(rule,value,callback){
        //     if(/^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/.test(value) == false){
        //         callback(new Error("请输入正确的IP地址"));
        //     }else{
        //         callback();
        //     }
        //   }, trigger: 'blur'
        //   }
        // ],
        cloudType: [
          {required: true, message: "请选择云管理", trigger: "change",},
        ],
      },
      formLabelWidth: "140px",
      //table
      tableData: [],
      //分页参数
      page: { 
        pageNum: 1,
        pageSize: 10
      },
      total: 0,
      current_page: 1,
      page_size_list: [10,15,20]
    };
  },
  methods: {
    async handleChange(file){
      console.log("handleChange",file)
      let data = await readFile(file.raw)//二进制数据
      console.log("readFile",data)
      let workbook = XLSX.read(data,{type: 'binary'})
      console.log("workbook",workbook)
      let worksheet = workbook.Sheets[workbook.SheetNames[0]]
      console.log("worksheet",worksheet)
      let sheetData = XLSX.utils.sheet_to_json(worksheet)
      console.log("sheetData",sheetData)
      this.show = false
      //读取到的数据修改成我们需要的
      let new_data = []
      sheetData.forEach(item=>{
        let obj = {}
        for(let key in character){
          if(!character.hasOwnProperty(key)) break
          let v = character[key]
          let text = v.text
          let type = v.type
          v = item[text] || ''
          type === 'string' ? (v=String(v)) : null
          type === 'number' ? (v=Number(v)) : null
          obj[key] = v
        }
        new_data.push(obj)
      })
      this.upload_tableData = new_data
      console.log("new_data",new_data)
      this.show = true
    },
    beforeUpload(file){
      console.log("beforeUpload",file)
    },
    export_data(){
      if(this.upload_tableData.length==0){
        this.$message({
          message: '请先选择导入数据',
          type: 'warning',
          showClose: true
        })
        return
      }
      let arr = this.upload_tableData.map((item,index)=>{
        return{
          编号: index+1,
          姓名:item.name,
          分数:item.score,
        }
      })
      let sheet = XLSX.utils.json_to_sheet(arr)
      let book = XLSX.utils.book_new()
      XLSX.utils.book_append_sheet(book,sheet,'sheet1')
      XLSX.writeFile(book,`user${new Date().getTime()}.xls`)
    },
    //表格数据
    cloudManagementList(pageList) {
      let page = pageList
      this.loading = true
      cloud_config_tabledata(page).then((res) => {
        if (res.data.code == "0") {
          this.tableData = res.data.data;
          this.tableData.forEach(item=>{
            if(item.cloudType === 1){
              item.cloudTypeName = "智慧校园"
            }else if(item.cloudType === 2){
              item.cloudTypeName = "智能家居"
            }else if(item.cloudType === 3){
              item.cloudTypeName = "智慧客控"
            }else if(item.cloudType === 4){
              item.cloudTypeName = "智能照明"
            }
          })
          this.total = res.data.page.total
        } else {
          this.$message.warning(res.data.message);
        }
        this.loading = false
      })
      .catch((err) => {
        this.loading = false
        console.log(err,"云管理表格数据获取失败");
        this.$message.error("云管理表格数据获取失败");
      });
    },
    handleClick(row) {
      console.log(row);
    },
    cancelClick(){
      this.dialogFormVisible = false
      // this.dialogFormVisible2 = false
    },
    handleClose(){
      this.dialogFormVisible = false
      // this.dialogFormVisible2 = false
    },
    //dailog对话框
    confirm_add(formName) {
      this.loadingsubmit = true
      this.confirmText = "提交中..."
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const loading = this.$loading({
            lock: true,
            text: 'Loading',
            spinner: 'el-icon-loading',
            background: 'rgba(0, 0, 0, 0.7)'
          });
          // this.dialogFormVisible2 = false;
          //本地表单校验通过，将表单信息提交到后台
          let form = {
            "cloudName": this.cloudForm.cloudName,
            "id": this.cloudForm.id,
            "ip": this.cloudForm.ip,
            cloudType: this.cloudForm.cloudType,
            cloudServiceName: this.cloudForm.cloudServiceName,
            smartLoudspeakerBoxServiceUrl: this.cloudForm.smartLoudspeakerBoxServiceUrl
          }
          api[this.apiName](form)
            .then((res) => {
              console.log(res,"新增或修改成功");
              if (res.data.code == '0') {
                //关闭dailog
                this.dialogFormVisible = false;
                //提示添加成功，更新表格数据
                this.$message.success(this.successMsg);
                this.cloudManagementList(this.page);
              } else {
                this.$message.warning(res.data.message);
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error("新增数据失败");
            })
            .finally(()=>{
              this.loadingsubmit = false
              this.confirmText = "确定"
              loading.close();
            })
        } else {
          this.$message.error("表单校验不通过");
          this.loadingsubmit = false
          this.confirmText = "确定"
        }
      });
    },
    //增加信息
    addCloud(){
      //清空表单数据
      this.cloudForm = {}
      Object.keys(this.cloudForm).forEach(
        (key) => (this.cloudForm[key] = "")
      );
      this.dialogFormVisible = true;
      //更改提交
      this.apiName = "addCloudInfo"
      this.successMsg = "添加成功"
      this.errorMsg = "添加失败"
      this.dailogTitle = "新增云管理"
      //重置表单
      if(this.$refs['subCloudForm'] !== undefined){
        this.$refs['subCloudForm'].resetFields();
      }
    },
    //删除信息
    delCloud(row) {
      //删除的一整行数据
      if (row && row.id) {
        this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(() => {
          //调用删除请求
          delCloudInfo(row.id)
            .then((res) => {
              if (res.data && res.status == 200) {
                console.log(res);
                this.$message.success("删除成功");
                //更新表格
                this.cloudManagementList(this.page);
              } else {
                this.$message.warning("删除失败");
              }
            })
            .catch((err) => {
              console.log(err);
              this.$message.error("删除出错");
            });
        }).catch(() => {
          this.$message({
            type: 'info',
            message: '已取消删除'
          });          
        }); 
      }else{
        this.$message.error("没有row数据")
        return
      }
    },
    //修改信息
    editCloud(row){
      this.dialogFormVisible = true;
      //数据回显
      this.cloudForm = {...row}
      this.apiName = "editCloudInfo"
      this.successMsg = "修改成功"
      this.errorMsg = "修改失败"
      this.dailogTitle = "修改云管理"
      // this.$refs['subCloudForm'].clearValidate(); // 仅清除验证
    },
    //改变分页
    changePage(page){
      this.page.pageNum = page
      this.cloudManagementList(this.page)
    },
    changeSize(val){
      console.log("一页几条数据",val)
      this.page.pageSize = val
      this.cloudManagementList(this.page)
    },
    //选择云服务类型
    changeType(event){
      console.log(event);
    }
  },
  mounted() {
    //页面加载，获取表格数据
    this.cloudManagementList(this.page);
  },
};
</script>

<style scoped>
.homeIndex{
  width: 100%;
  height: 100%;
  font-family: PingFang SC;
}
.addInfo {
  width: 100%;
  height: 80px;
  border-radius: 10px 10px 0 0;
  background: #ffffff;
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0 30px;
  box-sizing: border-box;
}
.infoName{
  font-size: 18px;
  font-family: PingFang SC;
  font-weight: 600;
  color: #000000;
}
.addBtn .el-button.is-round{
  width: 70px;
  height: 40px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #455AF7;
  border-radius: 5px;
}
.el-button--small, .el-button--small.is-round{
    padding: 3px 3px;
}
.addCloud{
  font-size: 16px;
}


/* 弹出框 */
.homeIndex >>> .el-dialog{
  width: 40%;
  background:  #F2F3F7;
}
.homeIndex >>> .el-dialog__header{
  display: flex;
  justify-content: center;
  font-weight: 500;
  background: #fff;
  
}
.homeIndex >>> .el-dialog__body{
  padding: 15px 15px 0 15px!important;
}
.submit{
  background: #455AF7;
  border-color: #455AF7;
}
.homeIndex >>> .el-pagination.is-background .el-pager li:not(.disabled).active{
  background: #455AF7!important;
}
.el-form{
  background: #fff;
  padding: 20px 10px;
  display: flex;
  flex-direction: column;
  align-items: center;
}
.homeIndex >>> .el-dialog__footer{
  padding: 0 15px 15px 15px!important;
}
.el-form-item{
  width: 85%;
}
.homeIndex >>> .el-select{
  width: 100%;
}
.homeIndex >>> .el-form-item__content{
  margin-left: 80px;
}
.dialog-footer{
  background: #fff;
  padding: 10px ;
}
.tableInfo{
  width: 100%;
  padding: 0 20px 20px 20px;
  box-sizing: border-box;
  background: #fff;
}
.tableInfo >>> .el-table td,
.tableInfo >>> .el-table th {
  text-align: center !important;
}
.tableInfo >>> th{
  background: #F2F3F7;
}

/* 分页 */
.pagination{
  width: 100%;
  display: flex;
  justify-content: flex-end;
  align-items: center;
  height: 80px;
  background: #fff;
  padding-right: 20px;
  box-sizing: border-box;
}
.edit{
  color: #455AF7!important;
}
.delete{
  color: #FB3F4E!important;
}
</style>


// WEBPACK FOOTER //
// src/pages/Home/homeIndex/index.vue